module.exports = __webpack_public_path__ + "img/u997.f375819a.svg";